import { render, staticRenderFns } from "./sales-order-table.vue?vue&type=template&id=4c6aedd3&scoped=true&"
import script from "./sales-order-table.vue?vue&type=script&lang=js&"
export * from "./sales-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6aedd3",
  null
  
)

export default component.exports